import { omit } from "@bonliva-crm/common";
import { TicketsFiltersList, dateNormalization, normalizationType } from "@tickets/utils";
import { FetchCallback, FilterManager } from "@search";
import { TodoCategory, TodoSearchFilter } from "@graphql";
import { TicketSearchFormData } from "./TicketSearchFormData";

export class TicketsSearchFilterManager extends FilterManager<TicketSearchFormData> {
  constructor(initialFilter: TicketSearchFormData, fetch: FetchCallback) {
    super({ initialFilter }, fetch);
  }

  get searchFilters(): TodoSearchFilter {
    return {
      ...omit(this.filter as any, "assignedTo", "assignedTeams", "createdByData"),
      assignedToTeams: this.filter.assignedTo
        .filter((x) => x.includes("_team"))
        .map((x) => x.replace("_team", "")),
      assignedToUsers: this.filter.assignedTo.filter((x) => !x.includes("_team")),
      createdDate: {
        from: dateNormalization(this.filter.createdDate.from, normalizationType.startOf),
        to: dateNormalization(this.filter.createdDate.to, normalizationType.endOf)
      },
      dueDate: {
        from: dateNormalization(this.filter.dueDate.from, normalizationType.startOf),
        to: dateNormalization(this.filter.dueDate.to, normalizationType.endOf)
      },
      createdBy: {
        include: this.filter.createdByData.filter((x) => !x.includes("not_")),
        exclude: this.filter.createdByData
          .filter((x) => x.includes("not_"))
          .map((x) => x.replace("not_", ""))
      }
    };
  }

  isFilterDirty(key: keyof TicketSearchFormData): boolean {
    return super.isFilterDirty(key);
  }

  isFilterDisabled(key: keyof TicketSearchFormData): boolean {
    switch (key) {
      case TicketsFiltersList.AssignedTo:
        return super.filter.category.some((i) =>
          [TodoCategory.MyTask, TodoCategory.DelegatedByMe].includes(i)
        );
      // AssignedBy
      case TicketsFiltersList.DelegatedBy:
        return super.filter.category.some((i) =>
          [
            TodoCategory.DelegatedByMe,
            TodoCategory.Birthday,
            TodoCategory.Applications
          ].includes(i)
        );
    }
    return false;
  }
}
